import React from 'react';
import loadable from '@loadable/component';
import config from '../../config';
import Preloader from '../../components/Preloader';

const DashboardPage = loadable(
  () => import(
    /* webpackChunkName: "dashboard-page-chunk", webpackPrefetch: true */
    './DashboardPage'
  ),
  {
    fallback: (
      <Preloader isDefault={config.isCustomApp} />
    ),
  }
);

export default DashboardPage;
